module.exports = __webpack_public_path__ + "static/net-image-25f64272bfa6958ede498a4535b74c80.png";